export default {
  lang: {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
  },

  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    quote: 'Get a Quote',
  },

  footer: {
    tagline:
      'Professional cleaning and facility services for homes and businesses. We keep your spaces clean, healthy and well-maintained with care and precision.',
    quickLinks: 'Quick Links',
    ourServices: 'Our Services',
    contactInfo: 'Contact',
    address: "Rte de Rosé 51, 1754 Avry-sur-Matran, Switzerland",
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    rights: 'All rights reserved.',
    services: [
      'Professional Cleaning',
      'Building Maintenance',
      'Concierge Services',
      'Outdoor Space Maintenance',
      'Specialized Cleaning',
      'Facility Management',
    ],
  },

  hero: {
    badge: 'Trusted by 5,000+ clients across Switzerland',
    titleLine1: 'A Clean Space is a',
    titleLine2: 'Happy Space',
    subtitle:
      'Limpia Sàrl delivers professional, eco-friendly cleaning services for homes and businesses. Experience the joy of a spotless, fresh environment — every single time.',
    ctaQuote: 'Get Your Free Quote',
    ctaServices: 'Explore Services',
    scroll: 'Scroll to explore',
  },

  servicesOverview: {
    badge: 'What We Offer',
    title: 'Professional Cleaning Services',
    subtitle:
      'From daily upkeep to deep cleans, we provide a full range of cleaning solutions designed around your needs.',
    items: [
      {
        icon: 'ri-sparkling-2-line',
        title: 'Professional Cleaning',
        description: 'Careful, regular cleaning to ensure clean, healthy and pleasant spaces every day.',
        features: ['Office cleaning', 'Building cleaning', 'Regular or one-off cleaning'],
      },
      {
        icon: 'ri-building-line',
        title: 'Building Maintenance',
        description: 'Daily upkeep of your buildings to preserve their cleanliness, comfort and quality.',
        features: ['Common areas', 'Stairwells & corridors', 'Laundry rooms'],
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Concierge Services',
        description: 'A local service for the smooth running and routine care of your buildings.',
        features: ['Common area checks', 'Waste management', 'Minor maintenance'],
      },
      {
        icon: 'ri-plant-line',
        title: 'Outdoor Space Maintenance',
        description: 'We keep your outdoor spaces clean, maintained and welcoming all year round.',
        features: ['Green space care', 'Lawn mowing', 'Hedge trimming'],
      },
      {
        icon: 'ri-brush-line',
        title: 'Specialized Cleaning',
        description: 'Interventions for situations requiring special attention and deep cleaning.',
        features: ['Post-construction cleaning', 'Post-move cleaning', 'Deep cleaning'],
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Facility Management',
        description: 'Professional coordination of maintenance services for your buildings.',
        features: ['Intervention coordination', 'Service monitoring', 'Maintenance planning'],
      },
    ],
  },

  stats: {
    labels: ['Years Experience', 'Clients Served', 'Professional Staff', 'Satisfaction Rate'],
  },

  why: {
    badge: 'Why Choose Limpia',
    titleLine1: 'Clean Spaces,',
    titleLine2: 'Happy Faces',
    subtitle:
      'We are not just another cleaning company. We are your partners in creating a healthier, happier environment — whether it is your home or your business.',
    rating: 'Average Rating',
    items: [
      {
        icon: 'ri-leaf-line',
        title: 'Eco-Friendly Products',
        description: 'We use biodegradable, non-toxic cleaning solutions that are safe for your family, pets, and the planet.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Insured & Bonded',
        description: 'Full insurance coverage and bonded staff give you complete peace of mind with every service.',
      },
      {
        icon: 'ri-user-star-line',
        title: 'Trained Professionals',
        description: 'Every team member undergoes rigorous training and background checks before entering your space.',
      },
      {
        icon: 'ri-thumb-up-line',
        title: 'Satisfaction Guaranteed',
        description: 'Not happy with something? We will come back and make it right — no questions asked, no extra charge.',
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Flexible Scheduling',
        description: 'Book weekly, bi-weekly, monthly, or one-time cleans. Morning, afternoon, or evening — we fit your life.',
      },
      {
        icon: 'ri-money-euro-circle-line',
        title: 'Competitive Pricing',
        description: 'Transparent, upfront pricing with no hidden fees. Quality cleaning that fits your budget.',
      },
    ],
  },

  testimonials: {
    badge: 'Testimonials',
    title: 'What Our Clients Say',
    subtitle: 'Real feedback from real people who trust us with their spaces.',
    items: [
      {
        name: 'Sophie Lambert',
        role: 'Homeowner',
        content:
          'Limpia has been cleaning my apartment for over two years now. The team is always on time, incredibly thorough, and the eco-friendly products they use give me peace of mind with my two young kids at home.',
      },
      {
        name: 'Marc Dubois',
        role: 'Office Manager',
        content:
          'We switched to Limpia for our office cleaning six months ago and the difference is night and day. Our workspace has never looked better, and the team is professional and discreet. Highly recommend for commercial needs.',
      },
      {
        name: 'Claire Muller',
        role: 'Property Manager',
        content:
          'As a property manager handling multiple buildings, I need a cleaning partner I can count on. Limpia delivers every single time — reliable, consistent, and their attention to detail is outstanding.',
      },
      {
        name: 'Thomas Weber',
        role: 'Restaurant Owner',
        content:
          'Cleanliness is everything in the restaurant business. Limpia handles our deep cleans with precision and care. They understand the standards we need and always exceed expectations.',
      },
    ],
  },

  quote: {
    badge: 'Get Started',
    title: 'Ready for a Cleaner Space?',
    subtitle:
      'Tell us about your cleaning needs and we will get back to you with a personalized quote within 24 hours. No obligations, no pressure — just a spotless space.',
    points: ['Free, no-obligation quote', 'Response within 24 hours', 'Customized to your needs'],
    form: {
      name: 'Full Name',
      namePlaceholder: 'Your full name',
      email: 'Email Address',
      emailPlaceholder: 'you@example.com',
      phone: 'Phone Number',
      phonePlaceholder: '+41 ...',
      service: 'Service Type',
      servicePlaceholder: 'Select a service...',
      serviceOptions: [
        'Professional Cleaning',
        'Building Maintenance',
        'Concierge Services',
        'Outdoor Space Maintenance',
        'Specialized Cleaning',
        'Facility Management',
      ],
      message: 'Tell us about your needs',
      messagePlaceholder: 'Describe your space, preferred schedule, and any special requirements...',
      submit: 'Request Your Free Quote',
    },
    success: {
      title: 'Thank You!',
      message: 'Thank you! We will get back to you within 24 hours.',
    },
    error: {
      title: 'Oops!',
      tryAgain: 'Try Again',
      network: 'Network error. Please try again later.',
    },
  },

  servicesPage: {
    header: {
      badge: 'OUR SERVICES',
      title: 'Professional solutions for your buildings and spaces',
      description:
        'Limpia Sàrl supports you with cleaning, maintenance and concierge services tailored to the needs of individuals, businesses, owners and property managers.',
    },
    learnMore: 'Learn more',
    items: [
      {
        title: 'Professional Cleaning',
        description: 'Careful, regular cleaning to ensure clean, healthy and pleasant spaces every day.',
        imageAlt: 'Professional office cleaning by Limpia Sàrl',
        features: [
          'Office cleaning',
          'Building cleaning',
          'Commercial surface cleaning',
          'Regular or one-off cleaning',
        ],
      },
      {
        title: 'Building Maintenance',
        description: 'We handle the daily upkeep of your buildings to preserve their cleanliness, comfort and quality.',
        imageAlt: 'Building maintenance — common areas by Limpia Sàrl',
        features: [
          'Common areas',
          'Stairwells and corridors',
          'Basements and communal rooms',
          'Laundry rooms',
          'Garages and parking',
        ],
      },
      {
        title: 'Concierge Services',
        description: 'A local service to ensure the smooth running and routine maintenance of your buildings.',
        imageAlt: 'Concierge services by Limpia Sàrl',
        features: [
          'Common area checks',
          'Waste management',
          'Minor maintenance work',
          'Monitoring building needs',
          'Reporting potential issues',
        ],
      },
      {
        title: 'Outdoor Space Maintenance',
        description: 'We keep your outdoor spaces clean, well-maintained and welcoming all year round.',
        imageAlt: 'Outdoor space maintenance by Limpia Sàrl',
        features: ['Green space maintenance', 'Lawn mowing', 'Hedge trimming', 'Outdoor cleaning'],
      },
      {
        title: 'Specialized Cleaning',
        description: 'Tailored interventions for situations requiring special attention and deep cleaning.',
        imageAlt: 'Specialized post-construction cleaning by Limpia Sàrl',
        features: [
          'Post-construction cleaning',
          'Post-move cleaning',
          'Deep cleaning',
          'One-off interventions',
        ],
      },
      {
        title: 'Facility Management',
        description: 'Professional coordination of maintenance services to simplify the daily management of your buildings.',
        imageAlt: 'Facility Management by Limpia Sàrl',
        features: [
          'Intervention coordination',
          'Service monitoring',
          'Maintenance planning',
          'Solutions for owners and property managers',
        ],
      },
    ],
    cta: {
      title: 'Need a solution tailored to your building?',
      text: "Let's discuss your needs and find a maintenance solution that suits your situation.",
      button: 'Request a quote',
      secondary: 'Contact us',
    },
  },

  about: {
    badge: 'Who We Are',
    title: 'About Limpia Sàrl',
    subtitle:
      'A local company dedicated to the upkeep and cleanliness of your buildings and spaces.',
    imageAlt: 'Building maintenance by Limpia Sàrl',
    section: {
      headline: 'A local company, at the service of your buildings',
      paragraph1:
        'Limpia Sàrl supports property owners, real estate agencies, companies and co-ownerships in the upkeep and cleanliness of their buildings and spaces.',
      paragraph2:
        'Our goal is simple: to offer a reliable, careful service adapted to the needs of each client. From regular cleaning to the maintenance of buildings and outdoor spaces, we offer flexible solutions to guarantee clean, well-maintained and pleasant environments every day.',
      paragraph3:
        'Attentive to our clients, we prioritize quality work, proximity and careful follow-up of every service.',
      highlights: [
        { icon: 'ri-shield-check-line', title: 'Reliability' },
        { icon: 'ri-award-line', title: 'Quality' },
        { icon: 'ri-hand-heart-line', title: 'Proximity' },
      ],
      cta: 'Learn more',
    },
  },

  contactPage: {
    badge: 'CONTACT',
    title: 'Get in touch with Limpia Sàrl',
    subtitle:
      'Have a question or need a solution for your building? Our team is happy to help.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    mapTitle: 'Find us',
  },
};